import { ValidationMessagesService } from './validation-messages.service';

export const Services = [
	ValidationMessagesService,
];
